import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { IconFlagComponent } from '../../../components/icon/icon-flag.component';
import { BusinessUnit, Account, AccountStatus } from '../../../domain/public-api';

export type AccountLabelType = 'short' | 'medium' | 'long' | 'single_line_long' | 'short_number_description';

@Component({
  selector: 'td-wb-account-label',
  templateUrl: 'account-label.component.html',
  styleUrls: ['account-label.component.scss'],
  imports: [
    NgTemplateOutlet,
    IconFlagComponent,
    TranslateDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountLabelComponent {

  @Input() account: Account;
  @Input() type: AccountLabelType;
  @ViewChild('shortLabelTemplate', { static: true }) shortLabelTemplate: TemplateRef<unknown>;
  @ViewChild('mediumLabelTemplate', { static: true }) mediumLabelTemplate: TemplateRef<unknown>;
  @ViewChild('longLabelTemplate', { static: true }) longLabelTemplate: TemplateRef<unknown>;
  @ViewChild('singleLineLongLabelTemplate', { static: true }) singleLineLongLabelTemplate: TemplateRef<unknown>;
  @ViewChild('shortNumberDescLabelTemplate', { static: true }) shortNumberDescLabelTemplate: TemplateRef<unknown>;

  constructor() {
  }

  isAccountClosed(): boolean {
    return this.account !== undefined && this.account.status === AccountStatus.CLOSED;
  }

  isOfiOrTdctAccount(): boolean {
    return this.account.businessUnit === BusinessUnit.OFI || this.account.businessUnit === BusinessUnit.TDCT;
  }

  getTemplate(): TemplateRef<unknown> {
    switch (this.type) {
      case 'short':
        return this.shortLabelTemplate;
      case 'medium':
        return this.mediumLabelTemplate;
      case 'long':
        return this.longLabelTemplate;
      case 'single_line_long':
        return this.singleLineLongLabelTemplate;
      case 'short_number_description':
        return this.shortNumberDescLabelTemplate;
      default:
        return this.longLabelTemplate;
    }
  }
}
